import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { ErCoverageReportService } from './erCoverageReport.service';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { AngularMultiSelect } from 'angular2-multiselect-dropdown';
declare var jquery: any;
declare var $: any;
@Component({
    moduleId: module.id,
    templateUrl: 'erCoverageReport.html',
    styleUrls: ['erCoverageReport.component.css']

})

export class ErCoverageReportComponent implements OnInit {
    @ViewChild('dropdownRef') dropdownRef: AngularMultiSelect;
    selectedYear: string;
    selectedHireMonth: string;
    selectedControlGroup: string;
    annulaizedMonthly: string = '0';
    errorMessage: string;
    downloadPdfInProgress: boolean = false;
    downloadExcelInProgress: boolean = false;

    Years: Array<string>;
    ControlGroups: any = [];
    workerDetails: Array<any> = [];

    public EmpByWorkYear: Array<any> = [];

    dataLoaded: boolean;
    public loading = false;
    public rows: Array<any> = [];
    public page: number = 1;
    public itemsPerPage: number = 10;
    public maxSize: number = 5;
    public numPages: number = 1;
    public length: number = 0;

    public columns: Array<any> = [
        { title: 'Controlled Group', className: 'va-m', name: 'controlGroup' },
        { title: 'Year', className: 'va-m', name: 'workYear' },
        { title: 'Month', className: 'va-m', name: 'workMonth' },
        { title: 'ACA Employment Status', className: 'va-m', name: 'workerPoolFteStatus' },
        { title: 'First Name', className: 'hidden-xs va-m', name: 'firstName' },
        { title: 'Last Name', className: 'va-m', name: 'lastName' },
        { title: 'Hours Worked', className: 'va-m', name: 'workedHours' },
        { title: 'FTE Count', className: 'va-m', name: 'workerPoolFteCount' },
        { title: 'Union Status', className: 'va-m', name: 'unionType' },
        { title: 'Union Name', className: 'va-m', name: 'unionName' },
    ];
    public config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        className: ['table', 'table-striped', 'table-bordered', 'table-hover']
    };
    userData: any;
    cgDropdownSettings = {};
    selectedCgValue: any[]
    showfiltererror: boolean = false;
    downloadpdf: any;
    downloadexcel: any;
    isfilterloaded: boolean = false;
    constructor(public elementRef: ElementRef, private _erCoverageReportService: ErCoverageReportService) {
        this.userData = JSON.parse(localStorage.getItem('token'));

    }

    ngOnInit(): void {

        this.cgDropdownSettings = {
            singleSelection: true,
            text: 'Select Controlled Group',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            classes: 'myclass custom-class single-dropdown',
            badgeShowLimit: 3
        };

        if (localStorage.getItem('storedData')) {
            this.onloadData();
        }

        this.setFilterData();

        this.selectedYear = '-1';
        this.selectedHireMonth = '-1';
        this.annulaizedMonthly = '0';
        this.selectedControlGroup = '-1';

        this.onChangeTable(this.config);
        this.dataLoaded = false;

    }

    onloadData(): void {
        const ssnData = JSON.parse(localStorage.getItem('storedData'));
        this.loading = true;
        this._erCoverageReportService.getSSnData(ssnData).subscribe(workdetails => {
            this.loading = false;
            this.dataLoaded = true;
            this.workerDetails = workdetails;
            this.onChangeTable(this.config);
        },
            error => this.errorMessage = <any>error);
    }
    Search(): void {
        this.page = 1;
        this.showfiltererror = false;
        let filterCriteria = this.getFilterValues();
        if (filterCriteria.selectedYear.length === 2 || filterCriteria.selectedControlGroup.length === 2) {
            this.showfiltererror = true;
            return
        }
        this.loading = true;
        this.isfilterloaded = true;
        filterCriteria.annulaizedMonthly = this.annulaizedMonthly;
        this._erCoverageReportService.getAnnulaizedMonthlyWorkersReportData(filterCriteria).subscribe(workdetails => {
            this.annualizedMonthlyReportData();
            this.loading = false;
            this.dataLoaded = true;
            this.workerDetails = workdetails;
            this.onChangeTable(this.config);
            this.isfilterloaded = false;
        },
            error => this.errorMessage = <any>error);
    }
    reset(): void {
        this.dataLoaded = false;
        this.selectedYear = '-1';
        this.annulaizedMonthly = '0';
        this.showfiltererror = false;
        if (this.userData.principal.roles[0] !== 'User' || this.userData.principal.controlGroups.length > 1) {
            this.selectedControlGroup = '-1';
            this.selectedCgValue = [];
        }
    }
    getFilterValues(): any {
        let year = this.selectedYear;
        if (year === '-1') {
            year = '\'\'';
        }

        let cg = this.selectedControlGroup;

        if (cg === '-1') {
            cg = '\'\'';
        }
        let filterCriteria: any = {
            selectedYear: year, selectedControlGroup: cg
        };
        return filterCriteria;
    }

    annualizedMonthlyReportData(): void {
        let filterCriteria = this.getFilterValues();
        if (filterCriteria.selectedYear.length === 2 || filterCriteria.selectedControlGroup.length === 2) {
            this.showfiltererror = true;
        } else {
            this.showfiltererror = false;
            this.annulaizedMonthly = '0';
            // this._erCoverageReportService.getAnnulaizedMonthlyWorkers(filterCriteria)
            //     .subscribe(counts => {
            //         if (counts === undefined || counts == null) {
            //             return;
            //         }
            //         counts.forEach((element: any) => {
            //             this.annulaizedMonthly = element.ANNUALIZED_MONTHLY_COUNT;
            //         });
            //     },
            //         (error: any) => this.errorMessage = <any>error);
            this._erCoverageReportService.getCoverageByYear(filterCriteria).subscribe((data:any) => {
                this.showfiltererror = false;
                this.EmpByWorkYear = data.fteCountByWorkMonthList;
                this.annulaizedMonthly = data.count
            }, error => this.errorMessage = <any>error);
        }
    }
    downloadExcel(): void {
        this.downloadexcel = true;
        let filterCriteria = this.getFilterValues();
        this.showfiltererror = false;
        this._erCoverageReportService.downloadExcelReport(filterCriteria).subscribe((data: any) => {
            this.downloadexcel = false
        }, (err: any) => (this.downloadexcel = false))
    }

    downloadPDF(): void {
        this.downloadpdf = true;
        let filterCriteria = this.getFilterValues();
        this._erCoverageReportService.downloadPDFReport(filterCriteria).subscribe((data: any) => {
            this.downloadpdf = false;
        }, (err: any) => (this.downloadpdf = false))
    }

    public changePage(page: any, data: Array<any> = this.workerDetails): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
        return data.slice(start, end);
    }


    public changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;
        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString, 'i');
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) =>
                item[config.filtering.columnName].match(new RegExp(this.config.filtering.filterString, 'i')));
        }

        let tempArray: Array<any> = [];
        filteredData.forEach((item: any) => {
            let flag = false;
            this.columns.forEach((column: any) => {
                if (item[column.name] == null) {
                    item[column.name] = '';
                }
            });
            this.columns.forEach((column: any) => {
                if (item[column.name].toLowerCase().match(new RegExp(this.config.filtering.filterString, 'i'))) {
                    flag = true;
                }
                else if (item[column.name].toUpperCase().match(new RegExp(this.config.filtering.filterString, 'i'))) {
                    flag = true;
                }
            });
            if (flag) {
                tempArray.push(item);
            }
        });
        filteredData = tempArray;
        return filteredData;
    }

    public changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }
        let columns = this.config.sorting.columns || [];
        let columnName: string = void 0;
        let sort: string = void 0;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }
        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }
            return 0;
        });
    }
    public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }
        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }
        let filteredData = this.changeFilter(this.workerDetails, this.config);
        let sortedData = this.changeSort(filteredData, this.config);
        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }
    ngOnDestroy() {
        localStorage.removeItem('storedData')
    }

    onChangeControlledGroup() {
        this.selectedControlGroup = this.selectedCgValue[0] ? this.selectedCgValue[0].itemName : '-1';
    }
    onItemSelect(item: any) {
        this.dropdownRef.closeDropdown()
    }
    setFilterData() {

        this._erCoverageReportService.getReportData().subscribe(data => {
            this.Years = data.WorkYears;

            if (this.userData.principal.roles[0] == 'User') {
                if (this.userData.principal.controlGroups.length == 1) {
                    this.cgDropdownSettings['disabled'] = true;
                    this.cgDropdownSettings = Object.assign({}, this.cgDropdownSettings);
                    this.selectedCgValue = [{ id: this.userData.principal.controlGroups[0], itemName: this.userData.principal.controlGroups[0] }]
                    this.selectedControlGroup = this.userData.principal.controlGroups[0]
                } else {
                    this.ControlGroups = this.userData.principal.controlGroups.filter((val: any) => data.ControlGroups.includes(val)).map((element: any) => { return { id: element, itemName: element } });
                }
            } else {
                this.ControlGroups = data.ControlGroups.map((element: any) => { return { id: element, itemName: element } });
            }
        },
            error => this.errorMessage = <any>error);
    }
}



// WEBPACK FOOTER //
// ./src/app/ErCoverageReport/erCoverageReport.component.ts